
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFanOn as ObiFanOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fan-on.js';
 
 
 

 
 export const ObiFanOn = createComponent({
   react: React,
   tagName: 'obi-fan-on',
   elementClass: ObiFanOnElement,
   events: {
     
   }
  });
 
 